import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AuthBootScreen from './AuthBootScreen';
import HomePage from '../../pages/home';

const AuthHomeRedirect: React.FC = () => {
  const { status } = useAuth();

  if (status === 'loading') {
    return <AuthBootScreen />;
  }

  if (status === 'authenticated') {
    return <Navigate to="/app" replace />;
  }

  return <HomePage />;
};

export default AuthHomeRedirect;
